var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfileBadgeWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "badge-bg",
    fill: "currentColor",
    stroke: "none",
    d: " M 18.2 8.4 Q 17.75 5.9 15.9 4.15 14.15 2.3 11.65 1.85 9.1 1.35 6.85 2.35 4.45 3.25 3.1 5.4 1.7 7.5 1.7 10 1.7 11.75 2.35 13.2 2.95 14.8 4.15 15.9 5.3 17.1 6.85 17.7 8.3 18.35 10 18.35 12.55 18.35 14.65 16.95 16.8 15.6 17.7 13.2 18.7 10.95 18.2 8.4 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    stroke: "none",
    d: " M 9.35 13.8 Q 9.4 13.95 9.7 14.15 L 10.2 14.2 10.6 13.95 Q 10.75 13.85 10.85 13.5 L 10.8 13.05 Q 10.7 12.8 10.5 12.65 10.3 12.5 10 12.5 9.7 12.5 9.45 12.75 9.2 13.1 9.2 13.35 9.2 13.65 9.35 13.8 M 10.85 6.7 Q 10.85 6.35 10.6 6.1 10.35 5.85 10 5.85 9.7 5.85 9.45 6.1 9.2 6.35 9.2 6.7 L 9.2 10.85 Q 9.2 11.2 9.45 11.45 9.7 11.7 10 11.7 10.35 11.7 10.6 11.45 10.85 11.2 10.85 10.85 L 10.85 6.7 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileBadgeWarning);
export default __webpack_public_path__ + "static/media/icon-profile-badge-warning.bd85bffdc4a8fa206fba85b8d3829268.svg";
export { ForwardRef as ReactComponent };